import { render, staticRenderFns } from "./FundingDistributions.vue?vue&type=template&id=976c266c"
import script from "./FundingDistributions.vue?vue&type=script&lang=js"
export * from "./FundingDistributions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports